var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3333 19H25.8333C26.1083 19 26.3333 19.225 26.3333 19.5V20.5C26.3333 20.7749 26.1087 21 25.8333 21H24.2646C23.9927 19.3103 22.5902 18 20.8333 18C19.0739 18 17.6302 19.3094 17.3842 21H15.2833C15.0396 19.3059 13.5952 18 11.8333 18C10.2739 18 9.01424 18.9906 8.53943 20.3594C8.36821 20.1156 8.26581 19.8203 8.26581 19.5V16H12.8333C13.1083 16 13.3333 15.775 13.3333 15.5C13.3333 15.225 13.1083 15 12.8333 15H8.26581V14H13.8333C14.1083 14 14.3333 13.775 14.3333 13.5C14.3333 13.225 14.1083 13 13.8333 13H8.26581V12H14.8333C15.1083 12 15.3333 11.775 15.3333 11.5C15.3333 11.225 15.1083 11 14.8333 11H8.26456V9.5C8.26456 8.67187 8.93643 8 9.76456 8H17.8333C18.6614 8 19.3333 8.67187 19.3333 9.5V11H20.9208C21.4458 11 21.9614 11.2125 22.3333 11.5875L24.7477 14.0019C25.1255 14.3797 25.3333 14.8816 25.3333 15.4156V19ZM19.3333 16H23.3333V15.4156L20.9192 13H19.3333V16Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83331 11H14.8333C15.1083 11 15.3333 11.225 15.3333 11.5C15.3333 11.775 15.1083 12 14.8052 12H6.80519C6.55719 12 6.33331 11.7188 6.33331 11.4719C6.33331 11.225 6.55719 11 6.83331 11ZM7.83331 13H13.8333C14.1083 13 14.3333 13.225 14.3333 13.5C14.3333 13.775 14.1083 14 13.8052 14H7.80519C7.55706 14 7.33331 13.775 7.33331 13.5C7.33331 13.225 7.55706 13 7.83331 13ZM11.8333 19C10.4521 19 9.33331 20.1187 9.33331 21.5C9.33331 22.8813 10.4521 24 11.8333 24C13.2146 24 14.3333 22.8813 14.3333 21.5C14.3333 20.1187 13.2146 19 11.8333 19ZM20.8333 19C19.4527 19 18.3333 20.1194 18.3333 21.5C18.3333 22.8806 19.4527 24 20.8333 24C22.2139 24 23.3333 22.8806 23.3333 21.5C23.3333 20.1187 22.2146 19 20.8333 19ZM13.3333 15.5C13.3333 15.225 13.1083 15 12.8333 15H6.83331C6.55719 15 6.33331 15.225 6.33331 15.5C6.33331 15.775 6.55719 16 6.80519 16H12.8052C13.1083 16 13.3333 15.775 13.3333 15.5Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryProgress);
export default __webpack_public_path__ + "static/media/delivery-progress.452dc0108a4adcde80c7d6b77c8d2036.svg";
export { ForwardRef as ReactComponent };